'use client';

import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import LouiseButton from '@/components/buttons/LouiseButton';
import ReactHtmlParser from 'react-html-parser';

type Props = { locale: string };

const ReadyTransformCustomerExperience = ({ locale }: Props) => {
  const { t } = useTranslation(locale);

  return (
    <section className="tw-mt-14 lg:tw-mt-14 tw-bg-transparent">
      <div className="tw-relative tw-z-10 tw-container tw-mx-auto tw-max-w-7xl">
        <div className="tw-text-center">
          <div className="tw-bg-gradient-to-r tw-from-blue-600 tw-to-purple-600 tw-rounded-3xl tw-p-8 lg:tw-p-12 tw-text-white tw-shadow-2xl">
            <h3 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-bold tw-mb-4 tw-font-['Lexend'] tw-text-white">
              {t('CtaReady/final-cta-title')}
            </h3>
            <p className="tw-text-lg tw-text-blue-100 tw-mb-8 tw-max-w-2xl tw-mx-auto tw-font-['Lexend']">
              {ReactHtmlParser(t('CtaReady/final-cta-text'))}
            </p>
            <LouiseButton
              color="white"
              cta={t('CtaReady/final-cta-btn')}
              ctaTarget="register"
              gradiant={false}
              locale={locale}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReadyTransformCustomerExperience;
